import { createFileRoute } from "@tanstack/react-router";
import ActionsPage from "@/pages/Actions";

export const Route = createFileRoute("/actions")({
  head: () => ({
    meta: [
      { title: "Done[x] — Actions (WIP)" },
      {
        name: "description",
        content:
          "Define reusable Done[x] flows that can be referenced by action_id in any message.",
      },
    ],
  }),
  component: ActionsPage,
});
